import {
  GET_PREPAIDCARDBALANCE_FAILED,
  GET_PREPAIDCARDBALANCE_INVALID_REQUEST,
  GET_PREPAIDCARDBALANCE_SUCCESS,
  GET_PREPAIDCARDBALANCE_NOTFOUND,
  LOADING_GET_PREPAIDCARDBALANCE,
  RESET_GET_PREPAIDCARDBALANCE
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  notFound: false,
  success: false,
  networkError: "",
  data: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GET_PREPAIDCARDBALANCE:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        notFound: false,
        success: false,
        networkError: "",
        data: {}
      };
    case GET_PREPAIDCARDBALANCE_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        notFound: false,
        failed: true,
        networkError: "",
        data: action.payload
      };

    case GET_PREPAIDCARDBALANCE_NOTFOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        notFound: true,
        failed: false,
        networkError: "",
        data: action.payload
      };
    case GET_PREPAIDCARDBALANCE_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        notFound: false,
        failed: false,
        networkError: "",
        data: action.payload
      };
    case GET_PREPAIDCARDBALANCE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        notFound: false,
        networkError: "",
        data: action.payload
      };

    case RESET_GET_PREPAIDCARDBALANCE:
      return (state = initialState);

    default:
      return state;
  }
};
